import { isEmpty } from "lodash";

export default function isEmptyValue(value) {
  const isNumberOrBoolean =
    typeof value == "number" || typeof value == "boolean";
  return isNumberOrBoolean ? false : isEmpty(value);
}
